var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-back__wrapper"},[_c('button',{staticClass:"btn-back",attrs:{"role":"navigation","type":"button"},on:{"click":_vm.navigate}},[_c('div',{staticClass:"btn-back__icon"},[_c('vb-icon',{attrs:{"name":"arrow_l","size":18,"color":_vm.sass('info')}})],1),_c('div',{staticClass:"btn-back__text"},[_c('span',[_vm._v(_vm._s(_vm.resolved_text))])])]),(_vm.forwards_only)?_c('vb-modal',{attrs:{"vb_options":{
      id: _vm.confirm_modal_id,
      title: 'Annulla prenotazione',
      ok_only: true,
      hide_footer: true,
      centered: true,
    }}},[_c('p',[_vm._v("Stiamo cancellando la tua selezione e dovrai ricominciare da capo.")]),_c('vb-button',{attrs:{"vb_options":{
        text: 'Continua',
        variant: 'outline-info',
        block: true,
      }},on:{"click":function($event){return _vm.confirm_cancel()}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }